export default __webpack_public_path__ + "static/office-d31831e2ffbbbd11c56e8dc50bbb62e2.jpg";